// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__kIiSL","notificationShow":"Notification_notificationShow__3uNB7"};